import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Volume2, VolumeX, Maximize2 } from "lucide-react";

export default function HeroShowcase() {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = () => {
    const v = videoRef.current; if (!v) return;
    const next = !muted; v.muted = next; setMuted(next);
  };
  const goFullscreen = () => {
    const v = videoRef.current; if (!v) return;
    (v.requestFullscreen || v.webkitEnterFullscreen)?.call(v);
  };

  return (
    <div className="relative w-full flex items-center justify-center py-6 lg:py-0" data-testid="hero-showcase">
      {/* Ambient gold spotlight */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="h-[80%] w-[80%] rounded-full bg-[radial-gradient(circle,_rgba(197,160,89,0.28),transparent_62%)] blur-2xl" />
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 1.02 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1], delay: 0.4 }}
        className="relative z-10 w-full max-w-[720px]"
      >
        <div className="relative w-full aspect-video rounded-sm overflow-hidden border border-[color:var(--relumia-gold)]/30 shadow-[0_20px_60px_-20px_rgba(60,45,20,0.35)] bg-black">
          <video
            ref={videoRef}
            data-testid="hero-video"
            className="w-full h-full object-cover"
            playsInline
            muted={muted}
            loop
            autoPlay
            preload="auto"
            poster="/videos/meet-relumia-poster.jpg"
          >
            <source src="/videos/meet-relumia.mp4" type="video/mp4" />
          </video>

          {/* Corner label */}
          <span className="absolute top-3 left-3 text-[9.5px] tracking-[0.25em] uppercase text-white/90 bg-black/40 backdrop-blur-md px-2.5 py-1 rounded-full border border-white/20">
            Brand Film · Now Playing
          </span>

          {/* Controls */}
          <div className="absolute bottom-3 right-3 flex items-center gap-2">
            <button
              onClick={toggleMute}
              data-testid="hero-video-mute"
              aria-label={muted ? "Unmute" : "Mute"}
              className="inline-flex items-center gap-1.5 rounded-full bg-white/85 backdrop-blur-md px-3 py-1.5 text-[11px] tracking-wide text-[color:var(--relumia-ink)] hover:bg-white transition-colors border border-white/70"
            >
              {muted ? <VolumeX size={12} strokeWidth={2} /> : <Volume2 size={12} strokeWidth={2} />}
              {muted ? "Tap to unmute" : "Sound on"}
            </button>
            <button
              onClick={goFullscreen}
              data-testid="hero-video-fullscreen"
              aria-label="Fullscreen"
              className="hidden md:inline-flex items-center justify-center h-8 w-8 rounded-full bg-white/85 backdrop-blur-md text-[color:var(--relumia-ink)] hover:bg-white transition-colors border border-white/70"
            >
              <Maximize2 size={13} strokeWidth={2} />
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
